<template>
    <div class="er-form-step">
        <div class="er-form-step-title">{{$store.getters.t('expenditure_request_form_step_enter_expense_amount')}}</div>

        <div class="targets">
            <div class="targets-title">{{$store.getters.t('expenditure_request_form_step_choose_target')}}</div>
            <div class="target-title" v-if="pets && pets.length">{{$store.getters.t('expenditure_request_form_step_your_pets')}}</div>
            <div class="target er-card er-card-xs" :class="{selected: expenditureRequest.target_pet_id === pet.id}" v-for="pet in pets" @click="selectTarget('target_pet_id', pet)">
                <div class="target-image">
                    <img v-if="pet.avatar" :src="'/storage' + pet.avatar.path.replace('/original/', '/preview/')" alt="">
                </div>
                <div class="target-info">
                    <div class="target-info-name">{{ pet.name }}</div>
                    <div class="target-info-funds">{{$store.getters.t('expenditure_request_form_step_available')}}: {{ pet.available_funds }}</div>
                </div>
            </div>
            <div class="target-title" v-if="projects && projects.length">{{$store.getters.t('expenditure_request_form_step_your_projects')}}</div>
            <div  class="target er-card er-card-xs" :class="{selected: expenditureRequest.target_project_id === project.id}" v-for="project in projects" @click="selectTarget('target_project_id', project)">
                <div class="target-image">
                    <img v-if="project.avatar" :src="'/storage' + project.avatar.path.replace('/original/', '/preview/')" alt="">
                </div>
                <div class="target-info">
                    <div class="target-info-name">{{ project.name }}</div>
                    <div class="target-info-funds">{{$store.getters.t('expenditure_request_form_step_available')}}: {{ project.available_funds }}</div>
                </div>
            </div>
            <div v-if="pets && !pets.length && projects && !projects.length" class="text-center mt-2 w-100">{{$store.getters.t('expenditure_request_form_step_no_pets_projects')}}</div>
        </div>
        <div class="form" v-if="expenditureRequest.target_project_id || expenditureRequest.target_pet_id">
            <div class="form-amount">
                <label>{{$store.getters.t('expenditure_request_form_step_expense_amount')}}</label>
                <input type="number" min="0" step="1" v-model="$v.expenditureRequest.amount.$model" @keyup="updateExpenditureRequest({key: 'amount', data: $event.target.value})">
                <div class="text-danger" v-if="$v.expenditureRequest.$error && !$v.expenditureRequest.amount.required"><small>{{$store.getters.t('expenditure_request_form_step_field_required')}}</small></div>
                <div class="text-danger" v-if="$v.expenditureRequest.$error && !$v.expenditureRequest.amount.maxValue"><small>{{$store.getters.t('expenditure_request_form_step_amount_exceeds_available')}}</small></div>
                <div class="text-danger" v-if="$v.expenditureRequest.$error && !$v.expenditureRequest.amount.minValue"><small>{{$store.getters.t('expenditure_request_form_step_amount_min')}}</small></div>
            </div>
            <div class="form-comment">
                <label>{{$store.getters.t('expenditure_request_form_step_comment')}}</label>
                <textarea :placeholder="$store.getters.t('expenditure_request_form_step_tell_about_expenses')" v-model="$v.expenditureRequest.purpose.$model" @keyup="updateExpenditureRequest({key: 'purpose', data: $event.target.value})"/>
                <div class="text-danger" v-if="$v.expenditureRequest.purpose.$error"><small>{{$store.getters.t('expenditure_request_form_step_field_required')}}</small></div>
            </div>
            <div class="form-files">
                <label>{{$store.getters.t('expenditure_request_form_step_attach_documents')}}</label>
                <input type="file" class="d-none" ref="files" @change="loadNewFiles($event)" multiple>
                <div class="documents">
                    <div class="add-document" @click="$refs.files.click()">
                        <div class="text-center">
                            <div class="add-document-plus">
                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26.25 12.25H15.75V1.75C15.75 1.28587 15.5656 0.840752 15.2374 0.512563C14.9092 0.184375 14.4641 0 14 0C13.5359 0 13.0908 0.184375 12.7626 0.512563C12.4344 0.840752 12.25 1.28587 12.25 1.75V12.25H1.75C1.28587 12.25 0.840752 12.4344 0.512563 12.7626C0.184375 13.0908 0 13.5359 0 14C0 14.4641 0.184375 14.9092 0.512563 15.2374C0.840752 15.5656 1.28587 15.75 1.75 15.75H12.25V26.25C12.25 26.7141 12.4344 27.1593 12.7626 27.4874C13.0908 27.8156 13.5359 28 14 28C14.4641 28 14.9092 27.8156 15.2374 27.4874C15.5656 27.1593 15.75 26.7141 15.75 26.25V15.75H26.25C26.7141 15.75 27.1593 15.5656 27.4874 15.2374C27.8156 14.9092 28 14.4641 28 14C28 13.5359 27.8156 13.0908 27.4874 12.7626C27.1593 12.4344 26.7141 12.25 26.25 12.25Z" fill="#0674EC"/>
                                </svg>
                            </div>
                            <div class="add-document-text">{{$store.getters.t('expenditure_request_form_step_add_photo')}}</div>
                        </div>
                    </div>
                    <div class="document" v-for="(previewImage, i) in previewImages">
                        <button type="button" class="document-delete" @click="deleteImage(i)">×</button>

                        <img :src="previewImage" >

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required, minValue, requiredIf, maxValue} from "vuelidate/lib/validators";
import {mapMutations, mapGetters} from "vuex";

export default {
    name: "ExpenditureRequestFormStep",
    data() {
        return {
            previewImages: [],
            pets: null,
            projects: null,
            selectedTarget: null,
        }
    },
    computed: {
        ...mapGetters({
            expenditureRequest: 'getterExpenditureRequest',
            submitNextClick: 'getterSubmitNextClick'
        }),
    },
    mounted() {
        this.loadPetAndProjects()
    },
    methods: {
        ...mapMutations({
            updateExpenditureRequest: 'setterExpenditureRequestParam',
            pushImage: 'pushImage',
            resetTarget: 'resetTarget',
            setterFormHasError: 'setterFormHasError',
            deleteImageByIndex: 'deleteImageByIndex'
        }),
        deleteImage(index){
            this.deleteImageByIndex(index)
        },
        selectTarget(key, target) {
            this.selectedTarget = target;

            this.resetTarget();
            this.updateExpenditureRequest({key, data: target.id});
        },
        loadPetAndProjects() {
            axios.get('/api/user/pets-n-projects', {params: {pet_status: 1, project_status: 1}}).then(response => {
                this.pets = response.data.data.pets;
                this.projects = response.data.data.projects;
            });
        },
        loadNewFiles(event) {
            // console.log(event)

            [...event.target.files].forEach(file => {
                this.pushImage(file);
            });
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 43) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    },
    watch: {
        'expenditureRequest.images'(images) {
            let previewImages = [];

            images.forEach(image => {
                image.convertToBase64(base64 => {
                    previewImages.push(base64);
                });
            })

            this.previewImages = previewImages;
        },
        submitNextClick() {
            this.$v.$touch();

            this.setterFormHasError(this.$v.$error);
        }
    },
    validations() {
        return {
            expenditureRequest: {
                amount: {
                    required,
                    minValue: minValue(0.01),
                    maxValue: maxValue(this.selectedTarget ? this.selectedTarget.available_funds : 0)
                },
                purpose: {
                    required: requiredIf(() => this.expenditureRequest.expenditure_id !== 4)
                }
            }
        }

    },
}
</script>

<style lang="scss" scoped>
.er-form-step {
    position: relative;

    &-title {
        font-weight: 700;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        margin-bottom: 50px;
    }

    .targets {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
        padding: 20px;
        border: 1px solid #ccc;
        border-radius: 10px;
        margin-bottom: 30px;

        &-title {
            position: absolute;
            left: 50%;
            font-size: 20px;
            font-weight: bold;
            width: 200px;
            text-align: center;
            background: #fff;
            border-radius: 15px;
            border: 2px solid #cccccc;
            margin-left: -100px;
            top: -17px;
        }

        .target {
            width: calc(33% - 15px);
            display: flex;
            cursor: pointer;
            margin-bottom: 15px;

            @media (max-width: 991px) {
                width: 100%;
            }

            &-title {
                width: 100%;
                margin-bottom: 10px;
            }

            &-image {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                border-radius: 50%;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

            }

            &-info {
                margin-left: 10px;


                &-name {
                    width: 100%;
                    font-size: 13px;
                }

                &-funds {
                    font-size: 13px;
                    color: #ccc;

                }
            }
        }
    }

    .form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;

        &-amount {
            width: calc(30% - 15px);

            @media (max-width: 991px) {
                width: 100%;
            }
        }

        &-comment {
            width: calc(70% - 15px);

            @media (max-width: 991px) {
                width: 100%;
            }
        }

        &-files {
            width: 100%;

            .documents {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                justify-content: flex-start;

                .document {
                    width: 25%;
                    height: 216px;
                    position: relative;

                    @media (max-width: 991px) {
                        height: 80px;
                    }
                    @media (max-width: 576px) {
                        width: 33%;
                    }

                    &-delete {
                        display: none;
                    }


                    &:hover {
                        transition: transform 200ms;
                        transform: scale(1.05);
                        z-index: 1;

                        .document-delete {
                            position: absolute;
                            top: -10px;
                            left: 50%;
                            margin-left: -10px;
                            width: 20px;
                            height: 20px;
                            z-index: 10;
                            background: #fff;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 1px solid red;
                            color: red;
                        }
                    }

                    img {
                        object-fit: cover;
                        width: 100%;
                        height: 100%;
                    }
                }

                .add-document {
                    width: 25%;
                    height: 216px;
                    background: #F1F2F4;
                    box-shadow: 0 1px 2px rgba(44, 47, 60, 0.06), 0 3px 10px rgba(44, 47, 60, 0.12);
                    border-radius: 5px;
                    cursor: pointer;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;

                    & > div {
                        @media (max-width: 576px) {
                            display: flex;
                            align-items: center;
                        }
                    }

                    @media (max-width: 991px) {
                        height: 80px;
                    }

                    @media (max-width: 576px) {
                        width: 100%;
                    }

                    &-plus {
                        svg {
                            @media (max-width: 576px) {
                                width: 17px;
                            }
                        }
                    }

                    &-text {
                        margin-top: 20px;
                        font-size: 12px;
                        line-height: 20px;

                        @media (max-width: 991px) {
                            margin-top: 10px;
                        }

                        @media (max-width: 576px) {
                            margin-top: 0;
                            margin-left: 10px;
                            font-size: 15px
                        }
                    }
                }
            }
        }
    }
}
</style>
